import React from "react";
import Trans from "../intl/Trans";
import { useSelector } from "react-redux";
import { authSelectors } from "../../redux/auth";
PermissionsErrorPage.propTypes = {};
/**
 * This page is rendered inside RouterErrorHandler with public/private layout or
 * directly by ApplicationErrorHandler without layout if getIdentity responded with 503
 */ export default function PermissionsErrorPage() {
    var isAdmin = useSelector(authSelectors.isAdmin);
    return /*#__PURE__*/ React.createElement("div", {
        className: "flex min-h-[calc(100vh-180px)] flex-col items-center justify-center px-4 text-center sm:px-6 lg:px-8"
    }, /*#__PURE__*/ React.createElement("h1", {
        className: "mb-6 mt-4 text-2xl font-bold dark:text-white"
    }, /*#__PURE__*/ React.createElement(Trans, null, "common.errors.pages.no-permissions.title")), /*#__PURE__*/ React.createElement("p", {
        className: "mt-3 text-gray-600 dark:text-gray-400"
    }, isAdmin ? /*#__PURE__*/ React.createElement(Trans, null, "common.errors.pages.no-permissions.subtitle") : /*#__PURE__*/ React.createElement(Trans, null, "common.errors.pages.no-permissions.sub-user.subtitle")));
}
